import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { CollectionsState } from './collections.state';
import { Observable } from 'rxjs';
import { Collection } from '../../models/collection';
import { GetCollections, ResetStore } from './collections.actions';

@Injectable({
  providedIn: 'root',
})
export class CollectionsFacade {
  private readonly store = inject(Store);

  @Select(CollectionsState.collections) collections$!: Observable<Collection[]>;

  get collections() {
    return this.store.selectSnapshot(CollectionsState.collections);
  }

  clearStore() {
    this.store.dispatch(new ResetStore());
  }

  getCollections(locale = 'es'): Observable<Collection[]> {
    return this.store.dispatch(new GetCollections(locale));
  }
}
